/* @flow */

import { lap } from '@braindate/ui/lib/token/mediaQuery';
import { getReadableColor } from 'plugin/light/util/lightUtils';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  upcomingBraindate: {
    width: '100%',
    minHeight: 188,
    maxWidth: 867,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: 188,

    [lap]: {
      flexDirection: 'row',
    },
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [21, 13, 23, 15],

    [lap]: {
      padding: [25, 24],
    },
  },
  buttonMenuRoot: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  buttonMenu: {
    color: ({ theme }: ThemeFunction) => getReadableColor(theme.accentColor),
  },
};
